import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { useAppContext } from "../app/AppContext";
import styles from "./SplashPage.module.css";

/** The V1 marketing splash, ported (PHASE1_PLAN.md stage 3.2). */
export function SplashPage() {
  const { experience } = useAppContext();
  const isMfa = experience.id === "myfirstagent";
  const suffix = isMfa ? "mfa" : "lya";
  return (
    <>
      <section className={styles.hero}>
        <div>
          <span className={styles.badge}>
            <FormattedMessage id={`splash.badge.${suffix}`} />
          </span>
          <h1 className={styles.title}>
            <FormattedMessage id={`splash.hero1.${suffix}`} />{" "}
            <span className={styles.titleAccent}>
              <FormattedMessage id={`splash.hero2.${suffix}`} />
            </span>
          </h1>
          <p className={styles.sub}>
            <FormattedMessage id={`splash.sub.${suffix}`} />
          </p>
          <div className={styles.ctaRow}>
            <Link to="/register" className={styles.ctaPrimary}>
              <FormattedMessage id="publicNav.startFree" />
            </Link>
            <Link to="/templates" className={styles.ctaSecondary}>
              <FormattedMessage id="splash.ctaTemplates" />
            </Link>
            <Link to="/pricing" className={styles.ctaSecondary}>
              <FormattedMessage id="splash.ctaPlans" />
            </Link>
          </div>
          <p className={styles.trust}>
            <FormattedMessage id={`splash.trust.${suffix}`} />
          </p>
        </div>
        <div className={styles.blockStack} aria-hidden="true">
          <div className={`${styles.block} ${styles.blockWhen}`}>
            <FormattedMessage id="splash.blocks.when" />
          </div>
          <div className={`${styles.block} ${styles.blockGoal}`}>
            <FormattedMessage id="splash.blocks.goal" />
            <span className={styles.blockValue}>
              <FormattedMessage id="splash.blocks.goalValue" />
            </span>
          </div>
          <div className={`${styles.block} ${styles.blockRepeat}`}>
            <FormattedMessage id="splash.blocks.repeat" />
            <span className={styles.blockValue}>
              <FormattedMessage id="splash.blocks.repeatValue" />
            </span>
          </div>
          <div className={`${styles.block} ${styles.blockTool}`}>
            <FormattedMessage id="splash.blocks.tool" />
          </div>
          <div className={`${styles.block} ${styles.blockShow}`}>
            <FormattedMessage id="splash.blocks.show" />
          </div>
        </div>
      </section>
      <section className={styles.features}>
        {(["feature1", "feature2", "feature3"] as const).map((feature) => (
          <article key={feature} className={styles.feature}>
            <h2 className={styles.featureTitle}>
              <FormattedMessage id={`splash.${feature}.title.${suffix}`} />
            </h2>
            <p className={styles.featureBody}>
              <FormattedMessage id={`splash.${feature}.body.${suffix}`} />
            </p>
          </article>
        ))}
      </section>
    </>
  );
}
